import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[uni-option-tmp]" })
export class UniOptionTemplateDirective {
  constructor(public template: TemplateRef<unknown>) {}
}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[uni-optgroup-tmp]" })
export class UniOptgroupTemplateDirective {
  constructor(public template: TemplateRef<unknown>) {}
}

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[uni-label-tmp]" })
export class UniLabelTemplateDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
